var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"byeback__logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo-blue-istyle-byeback-cz.jpg"),"alt":"BYEback - iStyle"}}),_c('div',{staticClass:"text"},[_vm._v(" Rozluč se se svým stávajícím zařízením a pořiď si výhodně nové ")])])
}]

export { render, staticRenderFns }